<template>
  <div class="column">
    <div class="content box">
      <p>
        <span class="is-size-4"> {{ simulation.label }} </span>
        <span
          class="button is-white is-pulled-right"
          @click="$emit('delete-simulation', simulation)"
          ><span class="fas fa-trash"></span
        ></span>
        <span
          class="button is-white is-pulled-right"
          @click="$store.dispatch('editSimulation', simulation)"
          ><span class="fas fa-edit"></span
        ></span>
      </p>
      <AttackBlock
        v-for="(attack, index) in simulation.attacks"
        :key="index"
        :attack="attack"
      ></AttackBlock>
      <DefenseBlock
        :defense="simulation.defense"
        :armor="simulation.armor"
      ></DefenseBlock>
    </div>
  </div>
</template>

<script>
import AttackBlock from "./AttackBlock";
import DefenseBlock from "./DefenseBlock";
export default {
  name: "SimulationCard",
  components: { DefenseBlock, AttackBlock },
  props: {
    simulation: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped></style>
